import { inject, Injectable } from '@angular/core';
import { SavePatientModalComponent, SavePatientModalData } from 'app/app-modules/modal/save-patient-modal';
import { firstValueFrom, map } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SavePatientModalService {
  private readonly _dialogService = inject(DialogService);
  private readonly _translateService = inject(TranslateService);

  async open({ data }: { data: SavePatientModalData }) {
    return firstValueFrom(
      this._dialogService
        .open(SavePatientModalComponent, {
          header: await firstValueFrom(this._translateService.get('general.editPatient')),
          modal: true,
          showHeader: true,
          closable: true,
          closeOnEscape: false,
          width: '96rem',
          style: { maxWidth: '95vw' },
          data,
        })
        .onClose.pipe(map(r => ({ saved: r?.saved === true })))
    );
  }
}
